import React from "react"

const VppMapping = {
 vpp1 : [4444501,
4448897,
4449354,
4510648,
4514200,
4517783,
4484150,
4472014,
4528318,
4530789,
4498269,
4495788,
4492450,
4506127,
4458137,
4458519,
4459084,
4459105,
4450317,
4439040,
4440797,
4467651,
4553663,
4487590,
4525081,
4413097,
4249762,
4313666,
4303107,
4401003,
4329074,
4368959,
4382700,
4383894,
4384001,
4392897,
4387018,
4340605,
4331881,
4596134,
4670446,
4673506,
4674121,
4666473,
4668474,
4665797,
4475703,
4584159,
4584652,
4584760,
4585379,
4585585,
4566697,
4681627,
4681631,
4681951,
4682293,
4686094,
4686350,
4687575,
4563012,
4624075,
4632409,
4608569,
4608603,
4688379,
4625523,
4629342,
4630377,
4641869,
4642513,
4637113,
4633514,
4573303,
4644869,
4646098,
4646105,
4646153,
4676594,
4677292,
4599126,
4600861,
4601632,
4601662,
4657296,
4657989,
4658363,
4611530,
4612098,
4612631,
4615772,
4646914,
4579293,
4588741,
4589544,
4592052,
4797023,
4788025,
4788828,
4760106,
4701959,
4745993,
4756601,
4757254,
4704471,
4705542,
4708958,
4716274,
4766906,
4808890,
4785216,
4781189,
4775322,
4738204,
4739089,
4740053,
4732072,
4733855,
4730072,
4819094,
4819144,
4820893,
4822099,
4815770,
4822785,
4359356,
4724773,
4728387,
4698259,
4700214,
4715182,
4833044,
4898614,
4898632,
4898666,
4898912,
4615427,
4755825,
4920687,
4921307,
4914834,
4915314,
4915686,
4916089,
4488253,
4924694,
4924723,
4925062,
4927319,
4839909,
4840055,
4551303,
4681595,
4906635,
4907288,
4907359,
4910383,
4912728,
4904438,
4904449,
5181026,
5184312,
5184550,
5150624,
5151248,
5151744,
5152616,
5154120,
5156333,
5160013,
5162865,
5163176,
5163627,
5163787,
5168921,
5170354,
5174019,
5174356,
5120386,
5121152,
5124303,
5124680,
5177885,
5178085,
5178132,
4947175,
4950011,
5004338,
5005528,
5007794,
5007953,
5008363,
5011375,
5011526,
5010414,
5011144,
5067271,
5062325,
5063506,
5070038,
5071004,
5068487,
5091712,
5076650,
5076748,
5078842,
5079913,
5079972,
5087813,
5088353,
5088677,
5088758,
5080540,
5084548,
5085224,
5141279,
5139549,
5139977,
5114655,
5114689,
5114995,
5127503,
5131303,
5132405,
5145559,
5148344,
5110110,
5111801,
4936904,
4936922,
4940007,
4940008,
4940213,
4940542,
4940693,
4996027,
5001850,
5001907,
5002327,
5002519,
4988930,
4989368,
4989627,
4828323,
4829052,
4879916,
4880219,
4881650,
4875870,
4876064,
4876092,
4877205,
4871991,
4871992,
4872220,
4883750,
4883901,
4498873,
4884288,
4884392,
4884830,
4880085,
4921351,
4918137,
4898417,
4903653,
4906614,
4933047,
4934355,
4980435,
4980535,
4980557,
4982556,
4983235,
4986090,
4973975,
4974608,
4977181,
4977378,
4980120,
5040907,
5044361,
5046333,
4865346,
4868074,
4868405,
4891678,
4895841,
4887046,
5024026,
5025236,
5025256,
5028364,
5030651,
5031059,
5017110,
5017901,
4961602,
4962128,
4965309,
5034827,
4952214,
4952826,
4956390,
4792985,
4877878,
4853772,
4854728,
4855072,
4855416,
4858082,
4858272,
4858304,
4869200,
4851936,
4843288,
4844150,
4967914,
4968008,
4968058,
4968604,
4969692,
4970982,
4971327,
4971384,
4971469,
4445185,
4959480,
4961130,
4946617,
4946927,
5053785,
5054037,
5056676,
5049347,
5050393,
5051114,
5060066,
5047461,
5196234,
5199269,
5202597,
5204738,
5214241,
5221854,
5221933,
5222486,
5243510,
5248618,
5239476,
5344173,
5344916,
5344943,
5398575,
5400384,
5383183,
5385707,
5387131,
5379813,
5380247,
5346344,
5346882,
5348291,
5403181,
5040676,
5372243,
5373396,
5393067,
5394798,
5394881,
5718986,
5721371,
5024431,
5661244,
5379710,
5028425,
5824189,
4700602,
5094752,
5098328,
5280533,
5476644,
5124848,
5595348,
4846375,
5625442,
5159457,
5141179,
4818768,
5147284,
5421854,
5441056,
5877323,
5602791,
5631638,
4488535,
5181090,
5514412,
5637603,
5557153,
4661306,
5525952,
5110861,
4369228,
4596536,
5111088,
5463773,
5106375,
4686361,
5775382,
5467366,
5619561,
5517900,
5370727,
4918282,
4933189,
5002516,
4988980,
5004413,
4971026,
4967794,
5060401,
5067938,
5074463,
4947207,
5031162,
5034174,
4865274,
4798964,
4819127,
4835390,
4886746,
4880913,
4874217,
5127801,
5141724,
4797071,
4964494,
4964456,
4967254,
4971311,
4976621,
4930136,
4916134,
5092094,
5005576,
5011109,
5013926,
4850765,
5602403,
4833958,
5070012,
5059816,
5028317,
5031196,
5021701,
5085507,
5135418,
5157421,
5121117,
5087909,
4646773,
4728502,
4868641,
4873570,
4877818,
4538206,
4538506,
4551328,
5637440,
5637450,
5624954,
5626188,
5627300,
5535029,
5535647,
5538227,
5538243,
5538256,
5539341,
5539755,
5617726,
5619758,
5620134,
5622268,
5613286,
5610320,
5476149,
5470115,
5466030,
5507749,
5579851,
5579893,
5581919,
5587622,
5587313,
5587631,
5545834,
5546094,
5546167,
5546378,
5514698,
5655116,
5655188,
5300635,
5497999,
5500119,
5556861,
5532649,
5565241,
5567173,
5568014,
5568394,
5568402,
5562299,
5562445,
5563231,
5520494,
5512453,
5542931,
5543394,
5640401,
5640437,
5520004,
5517690,
5602215,
5599523,
5548957,
5549004,
5549941,
5591609,
5592397,
5597066,
5597954,
5598053,
5333572,
5124835,
5425295,
5702929,
4986396,
5677277,
5274721,
5280394,
5205465,
5226409,
5162447,
5163362,
5166071,
5174007,
5183050,
4313616,
5189342,
5196069,
5676830,
5661497,
5670338,
5486590,
5413828,
5433027,
5432802,
5465536,
5358715,
5468814,
5477124,
5602969,
5626640,
5646900,
5607135,
5616197,
5525711,
5540272,
5500049,
5503285,
5421875,
5745828,
5067929,
5545107,
4716657,
5730599,
5543379,
5546339,
5385292,
5565846,
5538072,
5117336,
5390910,
5372950,
5370799,
5405907,
5412208,
5367458,
5366190,
5549853,
5710991,
5512143,
5460377,
5525954,
5230326,
5236377,
5315048,
5328206,
5240463,
5259129,
5264759,
5245479,
5874107,
5034933,
5721479,
4796912,
4799056,
5890616,
4444419,
4567006,
5909626,
4589316,
4884285,
4646913,
4652980,
5844191,
4690125,
5667274,
5669791,
5751585,
5754012,
4720226,
5875021,
5842085,
4940621,
4927313,
4934283,
5034647,
5123923,
5367818,
5368579,
5357798,
5492328,
5492423,
5492507,
5494816,
5495086,
5439058,
5441907,
5433063,
5442922,
5409700,
5332988,
5335752,
5335781,
5337923,
5338593,
5338617,
5340466,
5487442,
5488038,
5488132,
5488915,
5482250,
5483975,
5253010,
4584900,
5312202,
5450365,
5457561,
5458114,
5425369,
5426823,
5427317,
5427598,
5429966,
5430446,
5463133,
5465459,
4799423,
5309497,
5309652,
5309919,
5311507,
5291853,
5292856,
5341553,
5365605,
5365668,
5360180,
5361013,
5421062,
5405612,
5407113,
5419078,
5745596,
5781521,
5786775,
5703624,
5798355,
5672229,
5767076,
5767523,
4702002,
5713091,
5675007,
5675618,
5724699,
5726079,
5749147,
5570877,
5571367,
4391068,
5082026,
5285943,
4858536,
5906651,
5915702,
4872079,
5321059,
5324562,
5277807,
5277830,
5259493,
5265105,
5287170,
5287357,
5302551,
5305022,
5306330,
5306620,
5272096,
5104529,
4955850,
5014467,
5008370,
4793399,
4791680,
4864516,
4861733,
4730401,
5701372,
5091844,
5093827,
5094612,
5056680,
5583846,
5092155,
5463228,
5468924,
5473007,
5377523,
5433142,
5174122,
5321618,
5324118,
5226463,
5481771,
5227148,
5232809,
5528277,
5256083,
5379561,
5084962,
5385040,
5204777,
5216726,
5177255,
5329787,
5617444,
5396060,
5098259,
5401476,
4844378,
5393178,
5235461,
5372883,
5355330,
5355478,
5496963,
5499875,
5499679,
4874290,
5278285,
5275334,
5283453,
5034191,
5238513,
5239358,
5177541,
5306366,
5311863,
5333653,
4967234,
5267724,
5457962,
4704464,
5565292,
5027312,
5659462,
4608660,
5597929,
5637219,
4915848,
5230474,
5077453,
4950372,
4831770,
4916066,
5610230,
5314009,
5576390,
5576482,
5613294,
5383217,
5719933,
5538567,
5353389,
4355390,
5371309,
5656627,
5525763,
5657277,
5655261,
5302920,
5177768,
5154544,
5661546,
5442110,
5765535,
5771124,
5449788,
5780130,
5201487,
5565942,
5470690,
5734762,
5163826,
5354769,
5624948,
5625429,
5216758,
5641756,
5271876,
5400918,
4806636,
5787812,
5707280,
5213855,
4701808,
5523288,
5227483,
5527989,
5341631,
5342089,
5341430,
5264596,
5289733,
5450530,
5449845,
4980255,
4943327,
5365553,
5180759,
5321399,
5552969,
5235253,
5525663,
5303667,
5053079,
5398782,
5377264,
5763069,
5479381,
5565393,
2482566,
4960831,
5749347,
5099090,
5024905,
5078937,
5208233,
5430377,
5604597,
5735542,
5306567,
5429541,
5315130,
5484227,
5053947,
5021237,
5644804,
5236413,
5457197,
5530540,
4906713,
5924538,
4998440,
5449095,
5053655,
5255515,
5358519,
4854037,
4912567,
5249068,
4927122,
5311811,
5062766,
5454625,
5595168,
4896157,
4901046,
5192305,
5321175,
4513061,
5034029,
4936894,
5296948,
4824983,
4788527,
5617770,
4921628,
4878085,
5192617,
5196240,
5206206,
5208180,
5207802,
5210189,
5214038,
5216054,
5199569,
5390786,
5392348,
5392477,
5391883,
5396354,
5398154,
5398304,
5406406,
5405710,
5436502,
5439071,
5446939,
5414973,
5419074,
5415845,
5368777,
5371148,
5375512,
5380704,
5384592,
5219792,
5339122,
5344824,
5344035,
5349889,
5353007,
5353812,
4743436,
5034022,
5162405,
5494849,
5649011,
5524765,
5299854,
4650151,
4608727,
5121650,
5140285,
5147242,
4757279,
5151257,
4973610,
5159987,
5162017,
5163488,
5220011,
5177714,
5177810,
5181292,
4870599,
5138307,
5140575,
5140438,
4379250,
4850585,
4864227,
4880146,
4887735,
4888936,
4880601,
4895594,
4903902,
4903607,
4941223,
4945989,
4949455,
4930916,
5232761,
5232591,
5159515,
5248993,
5240073,
5265320,
5271466,
5278050],

 vpp2 : [5280668,
5256986,
5256479,
5258234,
5257998,
5259480,
5114622,
5121013,
5127795,
5131233,
5101010,
5302177,
5302858,
5303433,
5305642,
5306225,
5305815,
4895887,
5311538,
5318379,
5318821,
5321580,
5327747,
5290211,
5292301,
5286671,
5454583,
5453805,
5455646,
5459282,
5468780,
5037525,
5040382,
5040766,
5043835,
5045881,
5048533,
5050496,
5049879,
5053276,
5060107,
5063914,
5070026,
5071294,
5074521,
5079115,
5081541,
5082049,
5085194,
5088480,
5087649,
5087868,
5092080,
5092133,
4995256,
4998430,
5005113,
5007401,
5008082,
5013632,
4967394,
4973732,
4989460,
5028332,
5033326,
5033619,
5034035,
5302806,
5716958,
5555659,
5497385,
5063394,
5261541,
5544783,
5360843,
5135521,
5170522,
5332803,
5111721,
5360620,
5143183,
5612550,
4919118,
5361310,
4904111,
5373695,
5749802,
5312269,
5076994,
5171059,
5321527,
5186833,
5559596,
5143480,
5140132,
5110949,
5338457,
5324485,
5337570,
5458019,
5590153,
5548518,
5705154,
5405644,
5213379,
5087892,
2789988,
4983439,
5704846,
5151361,
2804428,
5173946,
5111066,
4885266,
5614953,
4685800,
5120342,
4970568,
4591513,
5670604,
3415528,
5424465,
5143804,
5159437,
5412512,
4686165,
4780508,
5204726,
4763154,
4773820,
4682078,
4799103,
4806941,
4884774,
5220147,
5161145,
5450289,
5226235,
5341589,
5520442,
5303626,
5523036,
5599458,
4535175,
4837234,
5578953,
4930970,
5233120,
5358543,
5511983,
5318730,
5519041,
5410795,
5559899,
5512430,
5315462,
5239967,
5472432,
5153027,
5070011,
4518130,
5245685,
5103216,
2625929,
4588783,
5326554,
5765451,
5293235,
5760911,
5062762,
4743449,
5262703,
5397789,
5365275,
5381769,
5584814,
4936307,
5735206,
5491799,
5373351,
5514678,
5891127,
5909913,
5353379,
5311628,
5530248,
5358422,
5127926,
4965408,
5834984,
5516303,
5336450,
5397729,
4865252,
4872046,
5763103,
5278155,
5779162,
5779882,
5784325,
5245536,
5758762,
5867758,
5163648,
4842617,
5169215,
4943324,
5495124,
5110586,
5508391,
5205560,
5124573,
4708900,
5568690,
5401149,
5002496,
5797508,
5378204,
5380577,
5671790,
5002503,
4980408,
5672196,
5027709,
5324838,
5392095,
5679104,
5426408,
5368717,
5635668,
5485538,
5044177,
4939972,
5478346,
5721808,
5398822,
5195437,
4930160,
5382167,
5533085,
4592585,
5379612,
5284438,
5261352,
4577081,
5444038,
5571842,
4912462,
5005511,
4894980,
4497993,
5202213,
4446065,
5177454,
4577965,
5010582,
5111069,
4980432,
5390416,
4920657,
4777208,
5332991,
5306378,
5779502,
4907561,
5242777,
4912317,
4974083,
5676774,
5074753,
5562877,
5202207,
5452288,
5427886,
5114810,
5309368,
5528073,
5576808,
5467632,
5536920,
5822233,
5281526,
5151310,
5172032,
5043714,
5017667,
5613236,
5171767,
5074690,
5177427,
5293420,
5479280,
5216755,
5424924,
5483002,
5625277,
4842624,
5028045,
5761978,
5053592,
5782045,
4887027,
4301812,
5354810,
5299124,
5302986,
5290133,
5327289,
5397671,
5401167,
5390666,
5394666,
5401620,
5402737,
4609109,
5267868,
5353220,
5277806,
5277986,
5347809,
5349213,
5344304,
4833561,
5014420,
5124864,
5127635,
5127879,
5120642,
5121337,
5123031,
5131756,
5131813,
5376077,
5379488,
5380241,
5359915,
5360556,
5361794,
5385575,
5388027,
5388261,
5388289,
5373739,
5335880,
5337960,
5338017,
5338060,
5340186,
5340248,
5329204,
5329946,
5330482,
5296841,
4868232,
5358445,
5358861,
5358931,
5303715,
5306146,
5318249,
5327211,
5308700,
5286716,
5370633,
5372692,
5367927,
5415156,
5415457,
5415639,
5417649,
5418050,
5003044,
5017423,
5097672,
5097800,
5097847,
5098297,
5100971,
5101323,
5101854,
5093516,
5095583,
5092115,
5195456,
5195798,
5196487,
5198510,
5198967,
5162643,
4928029,
5201699,
5205206,
5210215,
5217434,
5189660,
5192201,
5226187,
5236182,
5165318,
5150638,
5151015,
5151043,
5243223,
5243357,
5245762,
5246020,
5246504,
5249043,
5147060,
5147562,
5148373,
5153887,
5156493,
5186874,
5138139,
5140316,
5161170,
5183866,
5141032,
5142924,
5208147,
5208189,
5258656,
5258919,
5260275,
5264910,
5255415,
5255960,
5252472,
5227085,
5227291,
5228866,
5229302,
5229734,
5229868,
5231645,
5232738,
5233824,
5240196,
5242468,
5239944,
5171902,
5172001,
5169512,
4539220,
4539252,
4540225,
4547157,
4566233,
4592728,
4604663,
4657857,
4658379,
4712394,
4715305,
4677480,
4679405,
4681633,
4847221,
4847746,
4843066,
4843318,
4844345,
4844363,
4844488,
4879720,
4879852,
4880291,
4880996,
4881649,
4881676,
4881973,
4875661,
4875666,
4877743,
4878332,
4878335,
4871927,
4872096,
4884803,
4884966,
4760961,
4760965,
4761009,
4775216,
4781840,
4782063,
4864906,
4861138,
4861998,
4862156,
4857191,
4868614,
4868718,
4870645,
4870809,
4705190,
4669687,
4670434,
4727062,
4793606,
4784203,
4784590,
4851060,
4851736,
4807079,
4807814,
4812158,
4839893,
4840184,
4831731,
4832760,
4833957,
4828322,
4828377,
4830078,
4764619,
4767542,
4817866,
4818947,
4819134,
4819259,
4814341,
4821064,
5053171,
5053545,
5067295,
5073953,
5074456,
5070704,
5071477,
5063277,
5074770,
4596641,
4895120,
4895148,
4956176,
4998494,
4998613,
4998722,
4989532,
4995508,
5042654,
5077057,
5079947,
5082016,
5082194,
5082280,
5088413,
5088567,
5024442,
5027249,
5027660,
5028200,
5028586,
5108060,
5040459,
5040882,
5056925,
5056969,
5060884,
5047661,
4901742,
4855383,
4924060,
4927552,
4949083,
4946923,
5031017,
5031178,
4449872,
5117953,
4892469,
4658377,
4653780,
4936514,
4936711,
4937591,
5008578,
5008722,
5005246,
5008372,
4666536,
4723237,
4723458,
4740143,
4731918,
4734043,
4735289,
4743278,
4629307,
4621191,
4621490,
4600220,
4634174,
4634248,
4640970,
4636639,
4637169,
4645820,
4646048,
4646333,
4720096,
4611738,
4612607,
4614805,
4614952,
4745654,
4745675,
4685125,
4686298,
4676074,
4688801,
4689996,
4690016,
4690480,
4696984,
4697017,
4697041,
4751879,
4757290,
4757342,
4757357,
4756362,
4692686,
4692934,
4889892,
4898874,
4898910,
4766736,
4811463,
4921099,
4921177,
4921221,
4943311,
4907361,
4910120,
4910359,
4910558,
4980604,
4982906,
4982931,
4983072,
4986232,
4964823,
4967761,
4968007,
4968119,
4977419,
4979762,
4952641,
4955296,
4904198,
4904454,
4913198,
4876038,
4914785,
4915931,
4961263,
4961823,
4962305,
4959043,
4821584,
4822758,
4824800,
4824806,
4824812,
4825148,
4825910,
4826417,
4460741,
4696216,
4800275,
4788666,
4780364,
4781526,
5457404,
5457619,
5424345,
5452883,
5453028,
5553377,
5556818,
5557226,
5557471,
5548927,
5550989,
5475660,
5475977,
5475998,
5476724,
5538100,
5538178,
5538300,
5530129,
5530881,
5520170,
5520629,
5525140,
5526808,
5517055,
5512522,
5505122,
5505567,
5506277,
5506502,
5508132,
5511892,
5503699,
4311578,
4309423,
4336180,
4444275,
4449227,
4437095,
4331824,
4333056,
4408621,
4450251,
4450450,
4384047,
4346415,
4354231,
4355373,
4359038,
4391469,
4392186,
4396843,
4369319,
4475372,
4470546,
4141097,
4501084,
4506834,
4510531,
4537355,
4538784,
4534735,
4534958,
4535843,
4488123,
4488193,
4491649,
4528048,
4530873,
4531759,
4559263,
4561510,
4562209,
4516858],

 vpp3 : [
  4517491,
4519712,
4478758,
4479966,
4483448,
4550574,
4550638,
4466877,
4584755,
4585043,
4585397,
4585401,
4588556,
4589208,
4581153,
5621860,
4970998,
5764999,
5794696,
5794865,
4250768,
4738127,
4734752,
4849962,
5579891,
5561802,
5563159,
5606865,
5728682,
5717931,
5718427,
5719046,
5716510,
5788857,
5788937,
4591935,
5730641,
5856691,
5844627,
5899517,
5758812,
5783678,
5784254,
4386670,
5820267,
5822879,
5825698,
5827780,
4658343,
4690095,
4892330,
4896152,
4916196,
5738691,
5780028,
5665621,
5666555,
5685105,
5673420,
5675062,
5678738,
5679061,
5681362,
5581476,
5586367,
5569304,
5571413,
5571575,
4970802,
5599871,
5600167,
5634212,
5635563,
5318775,
5418837,
5419244,
5425018,
5429577,
5466293,
5468827,
5478570,
5478972,
5479063,
5441813,
5443611,
5444394,
5446462,
5446990,
5462396,
5486322,
5481263,
5379041,
5650263,
5644648,
5654641,
5655252,
5438748,
5439186,
5432614,
4644950,
5407126,
5449315,
5409746,
5410148,
5184403,
5208199,
5166356,
4906450,
5344900,
5447629,
5756765,
5067343,
5631873,
5610565,
5123149,
5040069,
5655040,
5648998,
5509130,
5413038,
5401283,
5435966,
5882927,
4853601,
4299221,
5492531,
5046599,
4672555,
5629336,
4844527,
4864922,
4800485,
4799186,
4792216,
4783729,
5529965,
5531993,
4773721,
5581462,
5335179,
5563043,
5537378,
4997996,
5542422,
5545281,
5547910,
4936228,
5592292,
4781187,
5063928,
5063349,
5082510,
5073751,
5076245,
5067364,
5063891,
5450199,
4947395,
4499503,
4950626,
5430626,
5435962,
5438945,
5466150,
5004346,
5475791,
5340203,
5347377,
5365921,
5574268,
5371118,
4887416,
4921074,
4986674,
5134615,
5135236,
5186827,
5183323,
5170553,
5044131,
4941953,
5506652,
5033426,
5013739,
5024342,
4646424,
5120597,
5050109,
5111096,
5308653,
5308950,
5305692,
4850210,
5299794,
5296665,
5259394,
5201923,
5210480,
5052984,
5274777,
5286728,
5104275,
5101673,
5092091,
5110845,
5223250,
5220074,
5219853,
5219832,
4959353,
4952595,
5418236,
5427901,
5425378,
5406254,
5398835,
5397334,
5397295,
5401516,
5380110,
5379692,
5383122,
4637355,
4763105,
4813981,
4895226,
4898664,
4961776,
4967992,
4962041,
4562693,
5488441,
5395871,
5037902,
5546532,
5497421,
5423702,
4964599,
5163210,
5530648,
5587270,
5620148,
5638012,
5640168,
5644038,
4857228,
5121659,
5666106,
5393981,
5613289
],

vpp4 : [
5163210,
5530648,
5587270,
5620148,
5638012,
5640168,
5644038,
4857228,
5121659,
5666106,
5393981,
5613289,
116422, 
5083258, 
5493413, 
5978972, 
4794230, 
4848698, 
5029809, 
5439614, 
4772351, 
4805677, 
4922723, 
3965089, 
4500594
],

vpp5 : [701644741],

vpp6: [698957011]
}

export default VppMapping